import React from 'react';
import { MapPinIcon, PackageIcon, ArrowRightIcon } from 'lucide-react';
export function WarehouseCard({
  id,
  name,
  location,
  country,
  flag,
  stock,
  machines,
  onViewDetails
}) {
  // Determine color based on stock value
  const stockValue = parseInt(stock);
  const stockStatus = stockValue <= 0 ? 'empty' : stockValue < 50 ? 'low' : 'good';
  const statusConfig = {
    empty: {
      bg: 'bg-red-100',
      text: 'text-red-700',
      dot: 'bg-red-500',
      label: 'Sin stock'
    },
    low: {
      bg: 'bg-amber-100',
      text: 'text-amber-700',
      dot: 'bg-amber-500',
      label: 'Stock bajo'
    },
    good: {
      bg: 'bg-emerald-100',
      text: 'text-emerald-700',
      dot: 'bg-emerald-500',
      label: 'Stock óptimo'
    }
  };
  const config = statusConfig[stockStatus];
  return <div className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-blue-300 transition-all hover:shadow-lg" data-id="element-6498">
      {/* Top banner with ID and flag */}
      <div className="flex justify-between items-center px-4 py-2 bg-gray-50 border-b border-gray-200" data-id="element-6499">
        <div className="flex items-center" data-id="element-6500">
          <span className={`h-6 w-6 flex items-center justify-center rounded-md font-bold text-xs ${config.bg} ${config.text}`} data-id="element-6501">
            {id}
          </span>
        </div>
        <span className="text-xl" data-id="element-6502">{flag}</span>
      </div>
      {/* Main content */}
      <div className="p-4" data-id="element-6503">
        <h3 className="font-bold text-lg mb-2 line-clamp-1" data-id="element-6504">{name}</h3>
        <div className="flex items-start text-gray-500 text-sm mb-4" data-id="element-6505">
          <MapPinIcon size={14} className="mr-1 mt-0.5 flex-shrink-0" data-id="element-6506" />
          <p className="line-clamp-2" data-id="element-6507">{location}</p>
        </div>
        {/* Stats section */}
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100" data-id="element-6508">
          {/* Stock indicator */}
          <div className="flex flex-col" data-id="element-6509">
            <div className="flex items-center gap-2 mb-1" data-id="element-6510">
              <span className={`h-2.5 w-2.5 rounded-full ${config.dot}`} data-id="element-6511"></span>
              <span className="text-sm font-medium" data-id="element-6512">{config.label}</span>
            </div>
            <div className="text-2xl font-bold" data-id="element-6513">{stock}</div>
          </div>
          {/* Machine count */}
          <div className="flex flex-col items-end" data-id="element-6514">
            <span className="text-sm text-gray-500 mb-1" data-id="element-6515">Máquinas</span>
            <div className="flex items-center" data-id="element-6516">
              <div className={`flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 mr-2`} data-id="element-6517">
                <PackageIcon size={16} className="text-blue-600" data-id="element-6518" />
              </div>
              <span className="text-xl font-bold" data-id="element-6519">{machines}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Action button */}
      <div className="border-t border-gray-100" data-id="element-6520">
        <button onClick={onViewDetails} className="w-full flex items-center justify-center gap-1 py-3 text-blue-600 hover:bg-blue-50 transition-colors font-medium" data-id="element-6521">
          Ver detalles
          <ArrowRightIcon size={16} data-id="element-6522" />
        </button>
      </div>
    </div>;
}